module.exports = __webpack_public_path__ + "static/media/tracking9.b58f1b7d.png";